const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_IMAGE;

export const fileURL = (path) => {
  if (!path || !API_BASE_URL) return null;

  if (path.startsWith("http")) {
    return path;
  }

  if (path.startsWith("uploads/")) {
    return `${API_BASE_URL}/${path}`;
  }

  return `${API_BASE_URL}/uploads/${path}`;
};
